"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const loanDetailsConstants_1 = require("./loanDetailsConstants");
const tabs_1 = __importDefault(require("../tabs/tabs"));
const expandableBox_1 = __importDefault(require("../expandableBox/expandableBox"));
const baseContent_1 = __importDefault(require("./baseContent/baseContent"));
const loanDetailsContent_1 = __importDefault(require("./loanDetailsTabContent/loanDetailsContent"));
const instalmentsContent_1 = __importDefault(require("./instalmentsTabContent/instalmentsContent"));
const otherLoansContent_1 = __importDefault(require("./otherLoansTabContent/otherLoansContent"));
const typesConstants_1 = require("../../constants/typesConstants");
const styles_1 = __importDefault(require("../../styles/styles"));
const loanId_1 = __importDefault(require("./loanId/loanId"));
const actionButtons_1 = __importDefault(require("./actionButtons/actionButtons"));
const actionsLoadingComponent_1 = __importDefault(require("../actionsLoadingComponent/actionsLoadingComponent"));
const eventConstants_1 = require("../../constants/eventConstants");
const repaymentsContent_1 = __importDefault(require("./repaymentsTabContent/repaymentsContent"));
const loanDetailsDefaultProps = {
    displayActions: true,
};
const LoanDetails = ({ loanData, actions, displayActions }) => {
    const [selectedTab, setSelectedTab] = react_1.useState(loanDetailsConstants_1.LOAN_DETAILS);
    const commonExtraContent = (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterCenter, styles_1.default.marginTen] },
        react_1.default.createElement(loanId_1.default, { loanId: loanData.id, loanIsVerifying: loanData.is_verifying }),
        displayActions && react_1.default.createElement(actionButtons_1.default, { actions: actions })));
    const baseComponent = (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(actionsLoadingComponent_1.default, { actionType: typesConstants_1.CUSTOM_ACTION_TYPE },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(baseContent_1.default, { loanData: loanData }),
                commonExtraContent))));
    const tabs = [{ key: loanDetailsConstants_1.LOAN_DETAILS, name: 'LOAN DETAILS' }];
    if (loanData.instalments.length > 0) {
        tabs.push({ key: loanDetailsConstants_1.INSTALMENTS, name: 'INSTALMENTS' });
    }
    if (loanData.transactions.length > 0) {
        tabs.push({ key: loanDetailsConstants_1.REPAYMENTS, name: 'REPAYMENTS' });
    }
    tabs.push({ key: loanDetailsConstants_1.OTHER_LOANS, name: 'OTHER LOANS' });
    let expandedComponent = react_1.default.createElement(react_native_1.View, null);
    const tabsComponent = (react_1.default.createElement(react_native_1.View, { style: { marginVertical: 20 } },
        react_1.default.createElement(tabs_1.default, { selectedTab: selectedTab, setSelectedTab: setSelectedTab, tabs: tabs })));
    if (selectedTab === loanDetailsConstants_1.LOAN_DETAILS) {
        expandedComponent = (react_1.default.createElement(react_native_1.View, null,
            tabsComponent,
            react_1.default.createElement(loanDetailsContent_1.default, { loanData: loanData })));
    }
    else if (selectedTab === loanDetailsConstants_1.INSTALMENTS) {
        expandedComponent = (react_1.default.createElement(react_native_1.View, null,
            tabsComponent,
            react_1.default.createElement(instalmentsContent_1.default, { instalments: loanData.instalments, transactions: loanData.transactions })));
    }
    else if (selectedTab === loanDetailsConstants_1.REPAYMENTS) {
        expandedComponent = (react_1.default.createElement(react_native_1.View, null,
            tabsComponent,
            react_1.default.createElement(repaymentsContent_1.default, { transactions: loanData.transactions })));
    }
    else if (selectedTab === loanDetailsConstants_1.OTHER_LOANS) {
        expandedComponent = (react_1.default.createElement(react_native_1.View, null,
            tabsComponent,
            react_1.default.createElement(otherLoansContent_1.default, { otherLoans: loanData.other_loans })));
    }
    const finalExpandedComponent = (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(actionsLoadingComponent_1.default, { actionType: typesConstants_1.CUSTOM_ACTION_TYPE },
            react_1.default.createElement(react_1.default.Fragment, null,
                expandedComponent,
                commonExtraContent))));
    return (react_1.default.createElement(expandableBox_1.default, { expandedComponent: finalExpandedComponent, baseComponent: baseComponent, title: "Loan Details", eventName: eventConstants_1.LOAN_INFO_EXPAND_PRESS }));
};
LoanDetails.defaultProps = loanDetailsDefaultProps;
exports.default = LoanDetails;
